import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=5387de2a&scoped=true"
import script from "./SlotMachine.vue?vue&type=script&lang=js"
export * from "./SlotMachine.vue?vue&type=script&lang=js"
import style0 from "./SlotMachine.vue?vue&type=style&index=0&id=5387de2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387de2a",
  null
  
)

export default component.exports